<template>
    <div>
        <div v-if="confirmAndContinue || emailSent">
            <signup-header />
            <signup-email-confirm v-if="confirmAndContinue" />
            <signup-email-sent v-else-if="emailSent" />
        </div>
        <signup-email-simple-confirm v-else />
    </div>
</template>
<script>
import SignupEmailSent from '@/components/SignupEmailSent';
import SignupEmailConfirm from '@/components/SignupEmailConfirm';
import SignupEmailSimpleConfirm from '@/components/SignupEmailSimpleConfirm';
import SignupHeader from '@/components/SignupHeader';

export default {
    name: 'signup-email',

    computed: {
        confirmAndContinue() {
            return !!this.$route.query.key && !!this.$route.query.id;
        },
        emailSent() {
            return !this.$route.query.key && !this.$route.query.id;
        },
    },
    components: {
        SignupHeader,
        SignupEmailSent,
        SignupEmailConfirm,
        SignupEmailSimpleConfirm,
    },
};
</script>
